
import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Params, Router} from '@angular/router';

import {Diagnostic} from '@awesome-cordova-plugins/diagnostic/ngx';


//import {GoogleAnalytics} from '@awesome-cordova-plugins/google-analytics/ngx';
import {IonContent, IonFooter, LoadingController, ModalController, Platform, ToastController} from '@ionic/angular';
import {switchMap, take, tap} from 'rxjs/operators';
import {UnrApiService} from '../../core/api/api.service';
import {Comment} from '../../core/api/resources/comment.resource';
import {RoadtripDetail} from '../../core/api/resources/roadtrip-detail.resource';
import {Step} from '../../core/api/resources/step.resource';
import {KmOrMiles} from '../../core/enum/km-miles.enum';
import {ModalActionEnum} from '../../core/enum/modal-action.enum';
import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {UnrAdsService} from '../../services/ads.service';
import {UnrFeedbackService} from '../../services/feedback.service';
import {MapsHelperService} from '../../services/maps-helper/maps-helper.service';
import {UnrSettingsService} from '../../services/settings/settings.service';
import {UnrGoogleMapComponent} from '../../shared/maps/components/google-map/google-map.component';
import {UnrMapKitMapComponent} from '../../shared/maps/components/mapkit-map/mapkit-map.component';
import {getAssetPathForRouteTypeIcon} from '../../utils/icon.util';
import {StepStateService} from '../step-details/step.state-service';
import {UnrImageViewer} from '../../shared/image-viewer/image-viewer.component';

import { UnrAdsComponent } from 'src/app/shared/ads/ads.component';
import { from, timer } from 'rxjs';
import { AdsConfig } from 'src/app/config/ads.config';
import { UnrAuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'unr-roadtrip-details-page',
  templateUrl: 'roadtrip-details.page.html',
  styleUrls: [
    'roadtrip-details.page.scss'
  ]
})
export class RoadtripDetailsPage {

  @ViewChild(IonContent, {static: false}) content: IonContent;
  @ViewChild(IonFooter, {static: true}) footer: IonFooter;

  trip: RoadtripDetail;
  distanceUnit: string;
  comments: Comment[];
  averageRating = 0;
  loading: HTMLIonLoadingElement;
  footerHeight = '0px';

  constructor(public activatedRoute: ActivatedRoute,
              private sanitizer: DomSanitizer,
              public api: UnrApiService,
              private feedbackService: UnrFeedbackService,
             
            
              private platform: Platform,
              private toastController: ToastController,
              private loadingCtrl: LoadingController,
          
              private diagnostic: Diagnostic,
              private modal: ModalController,
              private adsService: UnrAdsService,
              private modalCtrl: ModalController,
              private settingsService: UnrSettingsService,
               private authService: UnrAuthService,
              private router: Router,
              private statusBar: StatusbarService,
              private stepStateService: StepStateService,
             // private googleAnalytics: GoogleAnalytics
            ) {
             
  }




  ionViewWillEnter(): void {
 
    this.statusBar.changeStatusBar({ style: '' }, true);
    this.activatedRoute
      .queryParams
      .pipe(
        take(1)
      )
      .subscribe((queryParams: Params) => {
        const id = queryParams.id;
        this.getDetailsAndComments(id);
      });
  }

  async viewRouteOnMap(): Promise<void> {
    const mapType = this.platform.is('ios')
      ? UnrMapKitMapComponent
      : UnrGoogleMapComponent;

    const modal = await this.modalCtrl.create({
      component: mapType,
      componentProps: {
        [MapsHelperService.NAV_PARAM_GPX]: this.trip.gpxFile
      },
      backdropDismiss: true,
      showBackdrop: true,
      cssClass: 'modal--popup2 '   
    });
    await modal.present();
  }

  async onSelectImage(url: string): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UnrImageViewer,
      componentProps: {
        imageUrl: url
      },
      backdropDismiss: true,
      showBackdrop: true,
      cssClass: 'modal--popup'
    });
    await modal.present();
  }

  

async downloadGPXWeb(url: string, tripName: string): Promise<void> {
  try {
     await this.authService.showLoadingIndicator();
    const fileName = `${tripName}.gpx`.replace(/\s/g, '');
    
    // Fetch the file as blob (works on all browsers including Safari)
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();

    // Create a temporary link element
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);

    console.log('GPX file download triggered');
     await this.authService.hideLoadingIndicator();
  } catch (err) {
     await this.authService.hideLoadingIndicator();
    console.error('Failed to download GPX file:', err);
    alert('Failed to download GPX file. Please try again.');
  }
}

  

  onStepTap(step: Step): void {
    this.stepStateService.hasCommentedTrip = this.feedbackService.hasUserAlreadyProvidedFeedback(this.comments);
    this.stepStateService.trip = this.trip;
    this.stepStateService.step = step;
    this.router.navigate(['step-details']);
  }

  getIconLabel(): string {
    return this.trip
      ? getAssetPathForRouteTypeIcon(this.trip.label)
      : '';
  }

  async showAddCommentModal(): Promise<void> {
    if (this.feedbackService.hasUserAlreadyProvidedFeedback(this.comments)) {
      const toast: HTMLIonToastElement = await this.feedbackService.showToastFeedbackProvided();
      await toast.present();
      return;
    }

    const modal: HTMLIonModalElement = await this.feedbackService.showAddCommentAndRatingModalForTrip();
    const {data, role} = await modal.onDidDismiss();
    if (role === ModalActionEnum.Save) {
      (await this.feedbackService
        .postFeedbackForTrip(
          this.trip,
          data
        ))
        .pipe(
          tap(comments => {
            this.comments = comments;
            this.averageRating = this.feedbackService.getAverageRating(comments);
          })
        ).subscribe();
    }
  }

  private async createLoader(): Promise<void> {
    this.loading = undefined;
    this.loading = await this.loadingCtrl.create({
      backdropDismiss: true,
      showBackdrop: true,
      message: 'Loading'
    });
    await this.loading.present();
  }

  private dismissLoader(): void {
    if (this.loading) {
      this.loading.dismiss();
    }
  }

  private getDetailsAndComments(roadtripId: string): void {
    let kmOrMiles: KmOrMiles;
    this.settingsService.getKmOrMiles()
      .pipe(
        switchMap((kmMiles: KmOrMiles) => {
          kmOrMiles = kmMiles;
          return this.api.getRoadTripDetails(roadtripId, kmOrMiles);
        }),
        tap(async details => {
          this.trip = details;
          console.log(this.trip);
          this.distanceUnit = kmOrMiles;
          this.adsService.ads = details.ads;
          if (this.adsService.ads.length > 0) {
            const modal = await this.modalCtrl.create({
              component: UnrAdsComponent,
              cssClass: 'modal--popup'
            });
      
          //  this.googleAnalytics.trackView(`Ad: ${this.adsService.ads[0].advertiserName}`);
      
            from(modal.present())
              .pipe(
                switchMap(() => timer(1, 1000)),
                take(AdsConfig.durationInSeconds)
              )
              .subscribe(
                undefined,
                undefined,
                () => modal.dismiss()
              );
          }
          this.trip.mainImageFile = this.sanitizer.bypassSecurityTrustStyle(`url('${this.trip.mainImageFile}')`) as string;
        }),
        switchMap(() => this.feedbackService.getFeedbackForTrip(this.trip.id)),
        tap((comments: Comment[]) => {
          this.comments = comments;
          this.averageRating = this.feedbackService.getAverageRating(comments);
        })
      )

      .pipe(

      )
      .subscribe(() => {
       // this.googleAnalytics.trackView(`Roadtrip details: ${this.trip.tripName}`);
      });
  }
}
